import { formatDateToUTC } from 'app/utils/util-functions'

export const REASON_OPTIONS = [
  { value: 'Amendment', label: 'Amendment' },
  { value: 'Loan Activity', label: 'Loan Activity' },
  { value: 'Position Issues', label: 'Position Issues' },
  { value: 'Other', label: 'Other' },
]

export const OTHER_REASON = 'Other'

export type PlaceHoldFormValues = {
  reason: string
  customReason: string
  notes: string
  duration: 'indefinite' | 'until'
  untilDate: Date | null
}

export type HoldPayload = {
  reason: string
  notes?: string
  expirationDate?: string
}

// Maps the Place form values to the request payload: resolves "Other" to the
// custom reason, trims/omits blank notes, and serializes an "until" date to
// YYYY-MM-DD (indefinite holds carry no expirationDate).
export function buildPlaceHoldPayload(values: PlaceHoldFormValues): HoldPayload {
  const reason =
    values.reason === OTHER_REASON ? values.customReason.trim() : values.reason
  const notes = values.notes.trim()
  const payload: HoldPayload = { reason }
  if (notes) payload.notes = notes
  if (values.duration === 'until' && values.untilDate) {
    payload.expirationDate = formatDateToUTC(values.untilDate)
  }
  return payload
}
